export const credentialValue = {
    recaptcha_site_key: '6LfzrtIqAAAAAHsIJKzzZ_l6iKYCqiNO0oLcuaCl',
    recaptcha_secret_key: '6LfzrtIqAAAAABwidI3B_MKR2-goRp7i7-QbB6Sq',
}

